// Responsive breakpoints
window.BREAKPOINTS = {
    'md': '1024',
    'lg': '1366',
    'xl': '1920'
};

// Dictionary
import './lang.js';

// General and utility functions
import './permissions.js';
import './dark-mode.js';
import './anonymous.js';
import './history.js';
import './popups.js';
import './functions.js';

// Import hardcoded skills/styles and stats
import './data.js';

// Alpine objects
import './objects/main.js';
import './objects/select.js';
import './objects/checkbox-select.js';
import './objects/stat.js';
import './objects/league-filter.js';
import './objects/player-profile.js';
import './objects/account.js';
import './objects/find-players.js';
import './objects/find-player.js'; // this for the Africa mode
import './objects/save-player.js';
import './objects/comparison.js';
import './objects/save-comparison.js';
import './objects/saved.js';
import './objects/saved-players.js';
import './objects/saved-comparisons.js';
import './objects/rankings.js';
import './objects/scatter-graph.js';
import './objects/save-scatter-graph.js';
import './objects/saved-scatter-graphs.js';
